import {post} from '@/utils/request';
import{erpserver,erpplatserver,attendanceserver} from '@/utils/baseUrl';

export async function annualLeaveList(params) {
    return post(attendanceserver+'/kq/annualLeaveList', params, true)
}
export async function resetAnnualLeave(params) {
    return post(attendanceserver+'/kq/resetAnnualLeave', params, true)
}
export async function saveAnnualLeave(params) {
    return post(attendanceserver+'/kq/saveAnnualLeave', params, true)
}